export default __webpack_public_path__ + "static/media/griffon1.c9a74dc1.jpg";